import style from './style.module.scss';
import {Box, Col, Row} from 'components/Grid';
import {Typography} from 'components/Typography';
import {FooterLocation} from 'modules/footer/components/Footer/Location';
import {footerNavLinkList} from 'modules/footer/components/Footer/constants';
import Link from 'components/CustomRoutingLink';

export const FooterNav = () => {
    return (
        <div className={style.footerNav}>
            <Box>
                <Row>
                    <Col className={style.inner} lg={12} md={12} sm={12}>
                        <div className={style.nav}>
                            {footerNavLinkList &&
                                footerNavLinkList.map(({name, path, code}, idx) => (
                                    <Link
                                        data-auototest-target-id={`footer-main-menu-${code}`}
                                        data-autotest-target={`footer-main-menu`}
                                        href={path}
                                        key={idx}
                                    >
                                        <Typography className={style.text} variant={'label-16-r'}>
                                            {name}
                                        </Typography>
                                    </Link>
                                ))}
                        </div>
                        <div className={style.location}>
                            <FooterLocation />
                        </div>
                    </Col>
                </Row>
            </Box>
        </div>
    );
};
